// extracted by mini-css-extract-plugin
export default {"root":"ImageFromFile_root__85_n-","threeToTwoWrapper":"ImageFromFile_threeToTwoWrapper__3LzUr","rootForImage":"ImageFromFile_rootForImage__262gm"};